<ada-container
	horizontalSpacing="Medium"
	verticalSpacing="Medium"
	[padding]="ui.Spacing.SPACING_LARGE"
>
	<ada-table
		data-testid="properties-to-copy-table"
		id="propertiesToCopyTable"
		[checkboxesEnabled]="true"
		[data]="copyOptions$ | async"
		[includeActionsColumn]="false"
		[includeHeaderMenu]="false"
		[includeSorting]="true"
		(checkboxChanged)="changeCopySelection($event)"
		(columnHeaderSelected)="sortCopyOptions($event, copyOptions$)"
	></ada-table>
</ada-container>
